import Home from "@/router/home";
import CommonMixin from "@/common/mixins/common-mixin";

export default {
    mixins: [CommonMixin],
    data() {
        return {
            collapsed: false,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
            },
        }
    },
    computed: {
        logo() {
            if (this.$organization.extra && this.user.logo) return this.user.logo;
            return '/assets/images/logo.png';
        },
        menu() {
            let menu = [];
            const vm = this;
            const level = parseInt(this.user.role_level);
            const preset = this.preset.app;
            Home.forEach(function (item) {
                let can = true;
                if (item.meta && item.meta.level) { //判断级别够不够
                    can = item.meta.level.indexOf(level) >= 0;
                }
                if (item.meta && item.meta.mobile && !vm.$isMobile()) { // 仅仅在手机端显示
                    can = false;
                }
                if (item.meta && item.meta.wide && vm.$isMobile()) { // 处理要求在web端显示
                    can = false;
                }
                if (item.meta && item.meta.forbidden) { // 普通用户不可以创建会议
                    if (preset.create_meeting_forbidden) {
                        if (level < 3) {
                            can = false;
                        }
                    }
                }
                if (!item.hidden && can) {
                    const children = item.children;
                    if (children.length > 1) {  // 多个子项
                        let sub_menu = [];
                        children.forEach(function (child) {
                            let can = true;
                            if (child.meta && child.meta.level) { //子项也有权限
                                can = child.meta.level.indexOf(level) >= 0;
                            }
                            if (child.meta && child.meta.mobile && !vm.$isMobile()) { // 仅仅在手机端显示
                                can = false;
                            }
                            if (child.meta && child.meta.wide && vm.$isMobile()) { // 处理要求在web端显示
                                can = false;
                            }
                            if (child.meta && child.meta.forbidden) { // 普通用户不可以创建会议
                                if (preset.create_meeting_forbidden) {
                                    if (level < 3) {
                                        can = false;
                                    }
                                }
                            }
                            if (child.meta && child.meta.public && vm.$organization.org !== 'publics') { //共享客户端
                                can = false;
                            }
                            if (can && !(child.meta && child.meta.hidden)) { //子项隐藏
                                sub_menu.push(child);
                            }
                        });
                        menu.push({icon: item.icon, name: item.name, children: sub_menu});

                    } else if (children.length === 1) { //单个子目录
                        const child = children[0];
                        menu.push(Object.assign({icon: item.icon, children: false}, child))
                    }
                }
            });
            return menu;
        },
        pageKey() {
            if (this.$route.meta) {
                if (this.$route.meta.model) return this.$route.meta.model;
                else return this.$route.name;
            }
            return '';
        }
    },
    methods: {
        handleUserCommand(command) {
            if (command === 'logout') this.logout();
            else if (command === 'profile') this.$router.push("/profile");
            else if (command === 'password') this.$router.push("/password");
        },
        handleSelect() {
            this.collapsed = true;
        },
        logout: function () { //退出登录
            this.$confirm('&nbsp;&nbsp;将要退出系统, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true

            }).then(() => {
                this.$api('User.Logoff', {});
                this.clear();
                const return_url = this.$organization.signin_url;
                if (this.$organization.sso_out) {
                    // 判断 this.$organization.sso_out 字串是否包含?, 如果包含, 则加return_url
                    window.location.href = this.$organization.sso_out + (this.$organization.sso_out.indexOf('?') > 0? encodeURIComponent(return_url) : ''); // cas 跳转
                } else {
                    if (this.$organization.oauth_out) {
                        window.location.href = this.$organization.oauth_out + (this.$organization.oauth_out.indexOf('?') > 0? encodeURIComponent(return_url) : '');
                    } else {
                        this.$router.replace('/sign-in');
                    }
                }
            }).catch(() => {
            });
        },
        //折叠导航栏
        collapse() {
            this.collapsed = !this.collapsed;
            this.setCollapsed(this.collapsed);
        },
    },
    created() {
        this.collapsed = this.isCollapsed;
        if (this.$isMobile()) this.collapsed = true;
    },

}
